export default __webpack_public_path__ + "static/media/f_wdt_c_3.c10c681f.mp3";